// later: https://www.npmjs.com/package/react-combine-reducers
import { Reducer } from 'react';

import {
    API_FAILURE,
    API_REQUEST,
    API_SUCCESS,
    OVERRIDE_FORM_DATA,
    PageAction,
    SET_FORM_SUBMITTING,
    SET_LOADING,
    SET_PAGE_CONFIG,
    UPDATE_FORM_ITEM
} from '../actions';
import { PageState } from '../state/initialPageState';

export const pageReducer: Reducer<PageState, PageAction> = (state, action) => {
    if (action.type === SET_LOADING && state.loading !== !!action.payload) {
        return { ...state, loading: !!action.payload };
    }
    if (action.type === OVERRIDE_FORM_DATA) {
        return { ...state, formData: action.payload };
    }
    if (action.type === UPDATE_FORM_ITEM) {
        return { ...state, formData: { ...state.formData, ...action.payload } };
    }
    if (action.type === SET_FORM_SUBMITTING) {
        return { ...state, isFormSubmitting: !!action.payload };
    }
    if (action.type === SET_PAGE_CONFIG) {
        return { ...state, pageConfig: action.payload.pageConfig, pageName: action.payload.pageName };
    }
    if (action.type === API_REQUEST) {
        return { ...state, loading: true };
    }
    if (action.type === API_SUCCESS) {
        return { ...state, loading: false };
    }
    if (action.type === API_FAILURE) {
        return { ...state, loading: false, apiError: action.payload };
    }

    return state;
};
